import Question from "./question.js"
import ScoreOnlyQuestionComponent from "../components/questions/score-only-question.js"
class ScoreOnlyQuestion extends Question {
  component(mode) {
    return ScoreOnlyQuestionComponent;
  }
}

export default ScoreOnlyQuestion